export default __webpack_public_path__ + "static/media/05.a7df55b6.svg";